// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__UQj4S","icon":"SortAdornment_icon__3McWt","up":"SortAdornment_up__2Yc_3","down":"SortAdornment_down__2dZ9b","active":"SortAdornment_active__bcIQE"};